import { render, staticRenderFns } from "./TestQuestionsListItem.vue?vue&type=template&id=641324a2&scoped=true&"
import script from "./TestQuestionsListItem.vue?vue&type=script&lang=ts&"
export * from "./TestQuestionsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./TestQuestionsListItem.vue?vue&type=style&index=0&id=641324a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641324a2",
  null
  
)

export default component.exports